import { render } from "./InfraSummary.vue?vue&type=template&id=6182467a&scoped=true"
import script from "./InfraSummary.vue?vue&type=script&lang=js"
export * from "./InfraSummary.vue?vue&type=script&lang=js"

import "./InfraSummary.vue?vue&type=style&index=0&id=6182467a&lang=scss&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6182467a"]])

export default __exports__